import { render, staticRenderFns } from "./VesselsInvoices.vue?vue&type=template&id=401eda96&scoped=true&"
import script from "./VesselsInvoices.vue?vue&type=script&lang=js&"
export * from "./VesselsInvoices.vue?vue&type=script&lang=js&"
import style0 from "./VesselsInvoices.vue?vue&type=style&index=0&id=401eda96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401eda96",
  null
  
)

export default component.exports